import type { BreadcrumbCrumb } from "./useSettingsBreadcrumb";

export interface CrumbStack {
  pop: (id: string) => void;
  push: (id: string, crumb: BreadcrumbCrumb | null) => void;
}

// Keyed stack: each caller registers by id. The last registered wins (child
// overrides parent while mounted). On pop, the previous entry resurfaces —
// so child unmount naturally restores the parent crumb.
export function makeCrumbStack(
  set: (crumb: BreadcrumbCrumb | null) => void,
): CrumbStack {
  const entries: { id: string; crumb: BreadcrumbCrumb | null }[] = [];
  return {
    push(id: string, crumb: BreadcrumbCrumb | null) {
      const i = entries.findIndex(e => e.id === id);
      if (i >= 0) entries.splice(i, 1);
      entries.push({ id, crumb });
      set(crumb);
    },
    pop(id: string) {
      const i = entries.findIndex(e => e.id === id);
      if (i >= 0) entries.splice(i, 1);
      set(entries.at(-1)?.crumb ?? null);
    },
  };
}
